export enum FORM_TYPES {
  TRIAL = 'Trial',
  DIRECTBUY = 'DirectBuy',
  BUSINESSTRIAL = 'LPBusinessTrial',
  PURCHASE = 'purchase',
  PARTNER = 'Partner',
}

export enum TRIAL_TYPES {
  BUSINESS = 'business',
  MSP = 'msp',
  TEAMS = 'teams',
  FAMILIES = 'families',
  PREMIUM = 'premium',
  ENTERPRISE = 'enterprise',
}

export enum MODAL_TYPES {
  CHEVY = 'Chevy',
  UNIFIED = 'Unified',
  CHEVYPREMIUM = 'ChevyPremium',
  CHEVYPREMIUM_CONTROL = 'ChevyPremiumControl',
  CHEVYPREMIUM_CONTROL1 = 'ChevyPremiumControl1',
  CHEVYPREMIUM_PERSONAL = 'ChevyPremiumPersonal',
  UNIFIED_CHEVY_PREMIUM = 'UnifiedChevyPremium',
  PASSWORDGEN = 'PasswordGen',
  BIZMAX = 'BizMax',
}

export enum MODIFIER_TYPE {
  HERO = 'Hero',
}

export enum CONTENT_IDS {
  BUSINESS = '9AE89FD4-728F-4452-AFD4-15B1F8387CB4',
  PREMIUM = '7ABCBD5D-2460-4E22-B2DA-73C62C0D5A3F',
  FAMILIES = '755ED9BE-1F4F-4F47-B843-C98FDC37DD71',
  HERO = '41B0BD37-69BA-4CD8-8F1F-EBF197399FB8',
  CHEVY = '6bdc41f3-910e-4115-803e-c22686bb29dc',
}

export enum PRODUCT_SKUS {
  SKU_LPTEAMS = 'LPTeams',
  SKU_LPBUSINESS = 'LPBusiness',
  SKU_LPFAMILIES = 'LPFamilies',
  SKU_LPPREMIUM = 'LPPremium',
  SKU_LPBUSINESS_SSO_MFA = 'LPBusinessSSOMFA',
}

export enum LP_PLUS_MARKETO {
  PRODUCT_INTEREST = 'Plus',
  PROGRAM_NAME = 'GLB-WRQ-2026-09-Premium-Plus-Trial-Interest',
  PROGRAM_ID = '4489',
}
